import { type FunctionComponent } from "react";
import { useAssertBlankConversation } from "~/hooks/use-init-rag";
import { ChatLayout } from "~/screens/home/chat-layout";

/** Home route ("/") — always a blank new chat. Engaging (first message) redirects to /conversation/:id. */
export const HomeScreen: FunctionComponent = () => {
  useAssertBlankConversation();
  return <ChatLayout />;
};
